import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["county", "township", "community"]

  connect() {
    this.syncPlaces({ preserveInvalidSelection: true })
  }

  syncPlaces(options = {}) {
    const preserveInvalidSelection = options instanceof Event ? false : options.preserveInvalidSelection ?? true
    this.syncTownships({ preserveInvalidSelection })
    this.syncCommunities({ preserveInvalidSelection })
  }

  syncTownships({ preserveInvalidSelection }) {
    const county = this.countyTarget.value
    const selectedOption = this.townshipTarget.selectedOptions[0]
    let clearedInvalidSelection = false

    this.townshipOptions.forEach((option) => {
      if (option.value === "") return

      const alwaysVisible = option.dataset.alwaysVisible === "true"
      const matchesCounty = county === "" || option.dataset.county === county
      const shouldShow = alwaysVisible || matchesCounty || (preserveInvalidSelection && option.selected)

      option.hidden = !shouldShow
      option.disabled = !shouldShow
    })

    if (!preserveInvalidSelection && selectedOption && selectedOption.value !== "" && selectedOption.hidden) {
      this.townshipTarget.value = ""
      clearedInvalidSelection = true
    }

    if (clearedInvalidSelection && this.sentinelTownshipOption) {
      this.townshipTarget.value = this.sentinelTownshipOption.value
    } else if (this.shouldDefaultToSentinelTownship()) {
      this.townshipTarget.value = this.sentinelTownshipOption?.value || ""
    }

    this.refreshSelect(this.townshipTarget)
  }

  syncCommunities({ preserveInvalidSelection }) {
    const townshipId = this.townshipTarget.value
    const selectedOption = this.communityTarget.selectedOptions[0]
    let clearedInvalidSelection = false

    this.communityOptions.forEach((option) => {
      if (option.value === "") return

      const townshipIds = option.dataset.townshipIds.split(",").filter(Boolean)
      const alwaysVisible = option.dataset.alwaysVisible === "true"
      const matchesTownship = townshipId === "" || townshipIds.includes(townshipId)
      const shouldShow = alwaysVisible || matchesTownship || (preserveInvalidSelection && option.selected)

      option.hidden = !shouldShow
      option.disabled = !shouldShow
    })

    if (!preserveInvalidSelection && selectedOption && selectedOption.value !== "" && selectedOption.hidden) {
      this.communityTarget.value = ""
      clearedInvalidSelection = true
    }

    if (clearedInvalidSelection && this.sentinelOption) {
      this.communityTarget.value = this.sentinelOption.value
    } else if (this.shouldDefaultToSentinel()) {
      this.communityTarget.value = this.sentinelOption?.value || ""
    }

    this.refreshSelect(this.communityTarget)
  }

  refreshSelect(select) {
    if (window.jQuery?.fn?.select2) {
      window.jQuery(select).trigger("change.select2")
    } else {
      select.dispatchEvent(new Event("change"))
    }
  }

  get townshipOptions() {
    return this.townshipTarget.querySelectorAll("option[data-county], option[data-always-visible]")
  }

  get communityOptions() {
    return this.communityTarget.querySelectorAll("option[data-township-ids]")
  }

  get sentinelTownshipOption() {
    return Array.from(this.townshipOptions).find((option) => option.dataset.alwaysVisible === "true")
  }

  get sentinelOption() {
    return Array.from(this.communityOptions).find((option) => option.dataset.alwaysVisible === "true")
  }

  shouldDefaultToSentinelTownship() {
    if (!this.sentinelTownshipOption) return false
    if (this.townshipTarget.value !== "") return false

    const visibleNonSentinelOptions = Array.from(this.townshipOptions).filter((option) => {
      return option !== this.sentinelTownshipOption && !option.hidden && !option.disabled
    })

    return visibleNonSentinelOptions.length === 0
  }

  shouldDefaultToSentinel() {
    if (!this.sentinelOption) return false
    if (this.communityTarget.value !== "") return false

    const visibleNonSentinelOptions = Array.from(this.communityOptions).filter((option) => {
      return option !== this.sentinelOption && !option.hidden && !option.disabled
    })

    return visibleNonSentinelOptions.length === 0
  }
}
